import { Box, ButtonProps, Flex } from "@chakra-ui/react"
import Pathicon from "@pathwright/ux/src/components/pathicon/Pathicon"
import classNames from "classnames"
import { forwardRef } from "react"

// "MenuButton" is the working name, though not preferable since Chakra has a MenuButton component
// and this doesn't relate to that component at all. The main purpose of MenuButton is to
// share animation/styling and encapsulate the "down chevron" indicator.
const MenuButton = forwardRef<HTMLButtonElement, ButtonProps>(
  function MenuButton({ className, children, ...props }, ref) {
    return (
      // @ts-ignore: Chakra ButtonProps are not fully compatible with Box props,
      // we probably need to refactor this component (why aren't we using Chakra Button?)
      <Box
        ref={ref}
        className={classNames("group", className)}
        as="button"
        bg="none"
        p={0}
        cursor="pointer"
        transition="transform 200ms ease-in-out"
        pos="relative"
        _hover={{
          transform: "scale(1.1)"
        }}
        css={{
          "& > *": {
            boxShadow: "lg"
          }
        }}
        {...props}
      >
        <>
          {children}
          <Flex
            pos="absolute"
            bottom={0}
            right={0}
            transition="transform 200ms ease-in-out"
            transform="translate(10%, 10%)"
            _groupHover={{
              transform: "translate(10%, 30%)"
            }}
            bg="white"
            p={1}
            borderRadius="full"
            align="center"
            justify="center"
            boxShadow="lg"
            boxSize=".8rem"
          >
            <Pathicon icon="chevron-down" color="brand.600" size=".8em" />
          </Flex>
        </>
      </Box>
    )
  }
)

export default MenuButton
